module.exports = __webpack_public_path__ + "static/media/no-experiments.a1bbaadb.svg";